// bookconsulting
$(function() {
  let select_items = $(".select_item");
  $(".select_item").on("click", function() { 
    $(".active").removeClass("active"); 
    $(this).addClass("active");
    const index = select_items.index(this);
    $(".select_content").removeClass("show_item").eq(index).addClass("show_item");
  })
})

$(function() {
  let select_tabs = $(".select_item");
  let select_contents = $(".select_content");
  let select_images = $(".cover-item");
  $(".cover-item").on("click", function() { 
    const index = select_images.index(this);
    $(".select_item").removeClass("active").eq(index).addClass("active");
    $(".select_content").removeClass("show_item").eq(index).addClass("show_item");
  })
})

// event, school button
$('.applyBtn').click(function(){
  if(!$(".applyBtn.disabled").length){
    $(this).addClass("btn-hidden");
    $(".applyContent").addClass("show_content");
  }
});

$('.checkAgreement').click(function(){
    if($(this).is(':checked')){
        $(".agreement").removeClass("disabled"); 
        $(".agreementLink").removeClass("link-disabled"); 
    } else{
        $(".agreement").addClass("disabled"); 
        $(".agreementLink").addClass("link-disabled"); 
    }
});